<template>
  <div class="shows-preference">
    <h4 class="t-c m-b font-normal"> Great! Now try adding a couple of these podcasts to get started</h4>
    <p class="t-c m-b-3">This will appear in the 'My Shows' section of the app</p>

    <loader
      v-show="!data_loaded"
      label="Fetching Data..."/>

    <h5
      v-if="data_loaded && !categories.length"
      class="font-normal t-c">No podcasts found</h5>

    <podcast-list
      v-for="(next_category, index) in categories"
      :podcasts="next_category.podcast"
      :heading="next_category.category.name"
      :key="index"
      :selectable="true"
      type="podcast"
      @onSelect="onSelectionToggle"/>
    <div class="t-c m-b-3">
      <el-button
        type="plain"
        class="btn-transparent"
        @click="next">Skip</el-button>
      <el-button
        :disabled="!selectedPodcasts || !selectedPodcasts.length"
        type="primary"
        @click="next">Next</el-button>
    </div>
  </div>
</template>
<script>
import PodcastList from '../../components/PodcastList';
import Loader from '../../components/Loader';
import Podcast from '../../services/Podcast';
import User from '../../services/User';

export default {
  name: 'UserShows',
  components: {
    'podcast-list': PodcastList,
    loader: Loader,
  },
  data() {
    return {
      categories: [],
      data_loaded: false,
      selectedPodcasts: [],
      podcastProvider: new Podcast(),
      userProvider: new User(),
    };
  },
  mounted() {
    this.loadUserCategories();
    window.eventBus.$emit('onboarding-step-change', 3);
  },
  methods: {
    loadUserCategories() {
      this.data_loaded = false;
      this.userProvider.loadUserCategories().then((resp) => {
        if (resp && resp.length) {
          const categories = resp.map(item => item.category_uuid);
          this.loadCategoryPodcasts(categories.join());
        }
      }).catch(() => {
        this.data_loaded = true;
      });
    },
    loadCategoryPodcasts(categories) {
      this.podcastProvider.loadCategoryPodcasts(categories.join()).then((resp) => {
        if (resp && resp.length) {
          this.categories = resp.filter(item => item.podcast && item.podcast.length);
          this.updateSelectedPodcasts();
          this.loadUserPodcasts();
        }
        this.data_loaded = true;
      }).catch(() => {
        this.data_loaded = true;
      });
    },
    loadUserPodcasts() {
      this.podcastProvider.getPodcastsFromLibrary().then((resp) => {
        this.selectedPodcasts = resp || [];
        this.updateSelectedPodcasts();
        // console.log('user shows', resp)
      });
    },
    onSelectionToggle(podcast) {
      const isAdded = this.selectedPodcasts.find(item => podcast.id === item.podcast_uuid);

      if (isAdded && !podcast.isSelected) {
        this.removeUserCategory(podcast, false);
      } else if (!isAdded && podcast.isSelected) {
        this.addUserCategory(podcast, true);
      }
    },
    addUserCategory(podcast) {
      this.podcastProvider.addPodcastsToLibrary(podcast.id).then((resp) => {
        if (resp && resp.success) {
          podcast = {
            uuid: resp.uuid,
            podcast_uuid: podcast.id,
          };
          this.afterSuccess(podcast, true);
        }
      }).catch((error) => {
        this.showErrorMsg(error.response.data.error);
      });
    },
    removeUserCategory(podcast) {
      const data = this.selectedPodcasts.find(item => item.podcast_uuid === podcast.id);
      if (!data) { return; }
      this.podcastProvider.deletePodcastFromLibrary(data.uuid).then((resp) => {
        if (resp && resp.success) {
          this.afterSuccess(podcast, false);
        }
      })
        .catch((error) => {
          this.showErrorMsg(error.response.data.error);
        });
    },
    afterSuccess(category, isSelected) {
      if (isSelected) {
        this.selectedPodcasts.push(category);
      } else {
        this.selectedPodcasts = this.selectedPodcasts.filter(item => category.id !== item.podcast_uuid);
      }
      this.updateSelectedPodcasts();
    },
    updateSelectedPodcasts() {
      for (let i = 0; i < this.categories.length; i++) {
        let podcasts = this.categories[i].podcast || [];
        podcasts = podcasts.map((podcast) => {
          podcast.selected = !!this.selectedPodcasts.find(nextItem => nextItem.podcast_uuid === podcast.uuid);
          return podcast;
        });
        this.categories[i].podcast = podcasts;
      }
    },
    next() {
      this.$router.push('/complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/src/pages/onboarding/Shows.vue